import { GoogleOAuthProvider } from '@react-oauth/google'
import { useSearchParams } from 'react-router-dom'
import { useLoginWithGoogle } from './forms/login/useLoginWithGoogle'

function AppOauthInternal() {
    const [searchParams] = useSearchParams()
    const platform: 'ios' | 'android' | string | null = searchParams.get('platform')

    const libraryLoginWithGoogle = useLoginWithGoogle()

    const handleGoogleLogin = libraryLoginWithGoogle({
        onSuccess: async ({ code }) => {
            if (!['ios', 'android'].includes(platform || '')) {
                return
            }

            // const href = platform === 'ios' ? `menucaddy://oauth/google?auth-code=${code}` : ''
            const href = `menucaddy://oauth/google?auth-code=${code}`

            window.location.href = href
        }
    })

    return (
        <div className='py-12 px-8'>
            <button className='relative border border-black h-[40px] rounded-[100px] w-full font-google' onClick={handleGoogleLogin}>
                <p>Continue with Google</p>
                <img className='absolute top-1/2 -translate-y-1/2 left-3' src='/google-sso/google-logo.png' alt='Google' />
            </button>
            <p className='mt-8 text-secondary-500'>If you already have an account we'll log you in.</p>
        </div>
    )
}

export function AppOauth() {
    return (
        <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
            <AppOauthInternal />
        </GoogleOAuthProvider>
    )
}
